/*       */
import { combineReducers } from 'redux';

import { dataTableReducer, loadDataReducer, keepDataAtStart } from 'app/utils/redux/reducer-utils';
import {
    LOAD_LLM_PROVIDERS_STARTED,
    LOAD_LLM_PROVIDERS,
    UPDATE_LLM_SETTINGS_STARTED,
    UPDATE_LLM_SETTINGS,
} from 'store/actions/admin/llmProvidersActions';

export default combineReducers({
    list: dataTableReducer(LOAD_LLM_PROVIDERS_STARTED, LOAD_LLM_PROVIDERS, keepDataAtStart),
    update: loadDataReducer(UPDATE_LLM_SETTINGS_STARTED, UPDATE_LLM_SETTINGS),
});
